export { default } from './BancoAutoCarro';
